/**
 * stockMovementDisplayOrder - Ordem de exibição das movimentações nas abas da O.S. e do veículo.
 *
 * Movimentações gravadas na mesma operação (ex.: troca na conclusão da O.S.) têm o
 * mesmo horário. Nesse empate, a instalação (destino cliente/veículo) é exibida como a
 * mais recente, e a retirada logo abaixo. Horários diferentes seguem a ordem normal.
 * Usado só na aba Movimentações da O.S. e no Histórico da aba Equipamento do veículo.
 *
 * RELEASE: 2026-10-17 v1.0.0 - Versão inicial.
 */
interface Sortable {
  created_at: string;
  to_place: { type: string; vehicle_id?: string | null } | null;
}

/** Peso no desempate: instalação (cliente/veículo) vem antes das demais. */
const tieWeight = (m: Sortable) =>
  m.to_place?.type === 'customer' || m.to_place?.type === 'vehicle' || !!m.to_place?.vehicle_id ? 0 : 1;

/** Ordena do mais recente para o mais antigo, com desempate estável. Não altera o array original. */
export function sortMovementsForDisplay<T extends Sortable>(items: T[]): T[] {
  return items
    .map((m, i) => ({ m, i }))
    .sort((a, b) => {
      const diff = new Date(b.m.created_at).getTime() - new Date(a.m.created_at).getTime();
      if (diff !== 0) return diff;
      const w = tieWeight(a.m) - tieWeight(b.m);
      return w !== 0 ? w : a.i - b.i;
    })
    .map((x) => x.m);
}
